import {
  OPEN_MODAL,
  CLOSE_MODAL,
} from './constants';

export function openModal(index) {
  return {
    type: OPEN_MODAL,
    index,
  };
}

export function closeModal() {
  return {
    type: CLOSE_MODAL,
  };
}
